module.exports = __webpack_public_path__ + "static/media/power-bump-black-en.a178a194.png";